import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { PharmacyBase } from './PharmacyBase';

export const Pharmacy = types.compose(
  'Pharmacy',
  BaseEntity,
  PharmacyBase,
  types.model({
    phone: types.maybe(types.string),
    mobile: types.maybe(types.string),
    address: types.maybe(types.string),
    zipCode: types.maybe(types.string),
    group: types.maybe(types.string),
    zoneId: types.maybe(types.integer),
    density: types.maybe(types.integer),
    secretariatId: types.maybe(types.integer),
    latitude: types.maybe(types.number),
    longitude: types.maybe(types.number),
    x: types.maybe(types.number),
    y: types.maybe(types.number),
    prefDutyDayOn: types.maybe(types.string),
    prefDutyDayOff: types.maybe(types.string),
    municipalityId: types.maybe(types.integer),
}),
);

